export const BOTTOM_LIMIT_RANGE = 15;

export const TOP_LIMIT_RANGE = 100;
